import { Common, ApiBind } from './common.model';
import { DeviceModelGroupDeviceModel } from './device-model-group-device-model.model';

export class DeviceModelGroup extends Common {
  @ApiBind({ column: 'id' })
  id: number;

  @ApiBind({ column: 'name' })
  name: string;

  @ApiBind({ column: 'white_list', model: (values) => values.map(v => new DeviceModelGroupDeviceModel(v)) })
  whiteList: DeviceModelGroupDeviceModel[];

  @ApiBind({ column: 'black_list', model: (values) => values.map(v => new DeviceModelGroupDeviceModel(v)) })
  blackList: DeviceModelGroupDeviceModel[];

  @ApiBind({ column: 'updated_at' })
  updatedAt: string;

  public toDeleteItemJSON() {
    return { id: this.convertJSONObject(this.id), updated_at: this.convertJSONObject(this.updatedAt) };
  }
}
